import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../../../../../../components/editable-cell/editable-cell'

const FloodsInAccumulation: FC = () => {
    const ctx = useContext(EditableCellCtx)
    return (
        <Form.Item name={'floodsInAccumulation'} noStyle>
            <InputNumber autoFocus onBlur={ctx.onBlur} controls={false} />
        </Form.Item>
    )
}

export default FloodsInAccumulation
